import "@/App.css";
import { BrowserRouter, Routes, Route, Link, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Layout } from "@/components/site/Layout";
import Home from "@/pages/Landing";
import Facility from "@/pages/Facility";
import Careers from "@/pages/Careers";
import JobDetail from "@/pages/JobDetail";
import LeadershipPage from "@/pages/LeadershipPage";
import ImpactPage from "@/pages/ImpactPage";
import NewsPage from "@/pages/NewsPage";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

const NotFound = () => (
  <div className="mx-auto max-w-[1400px] px-5 pb-24 pt-[200px] md:px-10">
    <h1 className="font-display text-6xl font-bold uppercase text-[#001870]">Page not found</h1>
    <Link to="/" className="mt-6 inline-block text-[#001870] underline">Back to home</Link>
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SmoothScroll />
          <Routes>
            <Route element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="brownsville-facility" element={<Facility />} />
              <Route path="facility" element={<Navigate to="/brownsville-facility" replace />} />
              <Route path="leadership" element={<LeadershipPage />} />
              <Route path="our-impact" element={<ImpactPage />} />
              <Route path="news-and-media" element={<NewsPage />} />
              <Route path="careers" element={<Careers />} />
              <Route path="careers/:id" element={<JobDetail />} />
              <Route path="contact" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="admin/login" element={<AdminLogin />} />
            <Route path="admin" element={<Admin />} />
          </Routes>
          <Toaster theme="dark" position="bottom-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
